import React from 'react';
import PropTypes from 'prop-types';
import _ from 'helpers/no_conflict_lodash';
import CallContactLink from 'components/click_to_call/call_contact_link';

export default class PhoneList extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    phoneNumbers: PropTypes.arrayOf(PropTypes.shape({
      fax: PropTypes.bool,
      formatted: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired,
      primary: PropTypes.bool
    })),
    user: PropTypes.object.isRequired
  };

  numberIdentifier = phoneNumber => [phoneNumber.label, phoneNumber.number].join();
  numberLabel = phoneNumber => _.compact([phoneNumber.label, phoneNumber.primary ? 'Primary' : null]).join(', ');

  sortedNumbers = () => (
    _.sortBy(this.props.phoneNumbers, phoneNumber => [phoneNumber.primary ? 0 : 1, phoneNumber.label])
  );

  render() {
    return _.map(this.sortedNumbers(), phoneNumber => (
      <div key={this.numberIdentifier(phoneNumber)}>
        <CallContactLink
          fax={phoneNumber.fax}
          phone={phoneNumber.formatted}
          phoneNormalized={phoneNumber.number}
          targetName={this.props.name}
          user={this.props.user}
        />
        <span className="pl-2 text-muted">({this.numberLabel(phoneNumber)})</span>
      </div>
    ));
  }
}
